import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Site } from '@card-software/nexus-utilities';
import { ApiResponse } from '@card-software/library';

@Injectable({ providedIn: 'root' })
export class SiteProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/site`;

  constructor(private httpClient: HttpClient) {}

  // Full site catalog. Unlike SiteService.getSites() (only the logged-in user's
  // sites), this is needed so a UserSiteAssigner can see/resolve the names of every
  // site, including ones they don't belong to.
  getAllSites(): Observable<ApiResponse<Site[]>> {
    return this.httpClient.get<ApiResponse<Site[]>>(`${this.baseUrl}/all`);
  }
}
